import script from "./IPromo.vue?vue&type=script&setup=true&lang=js"
export * from "./IPromo.vue?vue&type=script&setup=true&lang=js"

import "./IPromo.vue?vue&type=style&index=0&id=0f1d3c4a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1d3c4a"]])

export default __exports__